import { render, staticRenderFns } from "./mergeLoadsModal.vue?vue&type=template&id=082958e3&scoped=true"
import script from "./mergeLoadsModal.vue?vue&type=script&lang=js"
export * from "./mergeLoadsModal.vue?vue&type=script&lang=js"
import style0 from "./mergeLoadsModal.vue?vue&type=style&index=0&id=082958e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082958e3",
  null
  
)

export default component.exports